import React from "react";
import PropTypes from "prop-types";
import { Box, Divider, Flex } from "@edreamsodigeo/prisma-design-system";
const DividerWithContent = ({
  children,
  color
}) => {
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    mx: "2x_small",
    flexGrow: "1"
  }, /*#__PURE__*/React.createElement(Divider, {
    color: color,
    orientation: "horizontal"
  })), /*#__PURE__*/React.createElement(Box, {
    mx: "1x_small"
  }, children), /*#__PURE__*/React.createElement(Box, {
    mx: "2x_small",
    flexGrow: "1"
  }, /*#__PURE__*/React.createElement(Divider, {
    color: color,
    orientation: "horizontal"
  })));
};
DividerWithContent.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string
};
DividerWithContent.defaultProps = {
  color: "neutral.40"
};
export default DividerWithContent;